import { render, staticRenderFns } from "./bill-list.vue?vue&type=template&id=5e1d2877&scoped=true"
import script from "./bill-list.vue?vue&type=script&lang=js"
export * from "./bill-list.vue?vue&type=script&lang=js"
import style0 from "./bill-list.vue?vue&type=style&index=0&id=5e1d2877&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e1d2877",
  null
  
)

export default component.exports